export default __webpack_public_path__ + "static/media/vertical-surfaces.334d384f.png";